import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signupWithLambda } from '../repository/authRepository';
import { setupAutoRefresh } from '../utils/tokenRefresh';

export const Signup: React.FC = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);

    if (!acceptedTerms) {
      setError('You must accept the terms and conditions to sign up.');
      return;
    }

    setIsLoading(true);

    const response = await signupWithLambda({
      username,
      email,
      password1,
      password2,
      terms_of_service: true,
      privacy_policy: true,
      cookie_policy: true,
    });

    if ('error' in response) {
      setError(response.error);
    } else if (response.access && response.refresh && response.user) {
      localStorage.setItem('access_token', response.access);
      localStorage.setItem('refresh_token', response.refresh);
      localStorage.setItem('user', JSON.stringify(response.user));
      setupAutoRefresh();
      navigate('/home');
    } else {
      navigate('/home');
    }

    setIsLoading(false);
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1 className="auth-title">Create your account</h1>
        <p className="helper-text">Start tracking your reading journey.</p>

        {error && <div className="alert error">{error}</div>}

        <form onSubmit={handleSubmit} className="grid" style={{ gap: '1rem' }}>
          <label className="field">
            <span className="field-label">Username</span>
            <input
              className="input"
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
              disabled={isLoading}
            />
          </label>

          <label className="field">
            <span className="field-label">Email</span>
            <input
              className="input"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              disabled={isLoading}
            />
          </label>

          <label className="field">
            <span className="field-label">Password</span>
            <input
              className="input"
              type="password"
              value={password1}
              onChange={(event) => setPassword1(event.target.value)}
              required
              disabled={isLoading}
            />
          </label>

          <label className="field">
            <span className="field-label">Confirm password</span>
            <input
              className="input"
              type="password"
              value={password2}
              onChange={(event) => setPassword2(event.target.value)}
              required
              disabled={isLoading}
            />
          </label>

          <label className="terms-checkbox">
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={(event) => setAcceptedTerms(event.target.checked)}
              disabled={isLoading}
            />
            <span>
              I agree to the <Link to="/terms">terms and conditions</Link>.
            </span>
          </label>

          <button className="button" type="submit" disabled={isLoading || !acceptedTerms}>
            {isLoading ? 'Signing up...' : 'Sign up'}
          </button>
        </form>

        <div className="helper-text" style={{ marginTop: '1rem' }}>
          <Link to="/login">Already have an account? Log in</Link>
        </div>
      </div>
    </div>
  );
};

export default Signup;
